import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import commonUtils from "../../script/utils/commonUtils";
import { Progress } from "./Progress";

const PdfPageStyle = styled.div`
    height: 80vh;
    canvas {
        margin-bottom: 5px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.greyLight};
    }
`;

export const PdfPage = ({ url, loadingText }) => {

    const containerRef = useRef();
    const [pdf, setPdf] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadPdf();
    }, []);

    useEffect(() => {
        if (pdf) {
            renderPdf();
        }
    }, [pdf]);

    const loadPdf = async () => {
        setLoading(true);
        const pdf = await commonUtils.loadPdfFromUrl(url);
        setPdf(pdf);
        setLoading(false);
    };

    const renderPdf = async () => {
        if (pdf) {
            const container = containerRef.current;
            container.innerHTML = ""; // Clear previous content
            for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                const canvas = document.createElement("canvas");
                container.appendChild(canvas);
                const context = canvas.getContext("2d");

                const page = await pdf.getPage(pageNum);
                const unscaledViewport = page.getViewport({ scale: 1 });
                const scale = container.clientWidth / unscaledViewport.width;
                const viewport = page.getViewport({ scale });

                canvas.height = viewport.height;
                canvas.width = viewport.width;

                const renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                await page.render(renderContext).promise;
            }
        }
    };


    return (
        <PdfPageStyle>
            <Progress loading={loading} text={loadingText} >
                <div ref={containerRef} />
            </Progress>
        </PdfPageStyle >
    );
};